// extracted by mini-css-extract-plugin
module.exports = {"addButton":"styles_addButton__2VHsQ","responsive":"styles_responsive__3aOCL"};